// src/pages/TestCompset.js
import React, { useState, useEffect } from 'react';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

function TestCompset() {
  const [user, setUser] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [hotelsFromHotelsEndpoint, setHotelsFromHotelsEndpoint] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadEverything = async () => {
      // 1. Usuario desde localStorage
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }

      try {
        // 2. Dashboard (el que tiene el compset)
        const dashRes = await fetch(
          `${process.env.REACT_APP_API_URL}/api.php?path=dashboard`,
          { headers: getAuthHeader() }
        );
        const dashJson = await dashRes.json();
        setDashboardData(dashJson);

        // 3. Endpoint de hoteles (el que usa DataEntry)
        const hotelsRes = await fetch(
          `${process.env.REACT_APP_API_URL}/api.php?path=hotels&limit=999`,
          { headers: getAuthHeader() }
        );
        const hotelsJson = await hotelsRes.json();
        setHotelsFromHotelsEndpoint(hotelsJson);

      } catch (err) {
        console.error('Error en diagnóstico:', err);
      } finally {
        setLoading(false);
      }
    };

    loadEverything();
  }, []);

  if (loading) {
    return <div style={{ padding: '50px', fontSize: '20px' }}>Cargando diagnóstico...</div>;
  }

  return (
    <div style={{ padding: '40px', fontFamily: 'monospace', background: '#f9f9f9', minHeight: '100vh' }}>
      <h1>DIAGNÓSTICO COMPSET – USUARIO ACTUAL</h1>
      
      <h2>1. Usuario desde localStorage</h2>
      <pre>{JSON.stringify(user, null, 2)}</pre>

      <h2>2. Respuesta completa de /api.php?path=dashboard</h2>
      <pre>{JSON.stringify(dashboardData, null, 2)}</pre>

      <h2>3. Respuesta de /api.php?path=hotels&limit=999</h2>
      <pre>{JSON.stringify(hotelsFromHotelsEndpoint, null, 2)}</pre>

      <hr />

      <h2>¿Qué compset debería ver este usuario?</h2>
      {dashboardData?.success && dashboardData?.dashboardData?.[0] ? (
        <>
          <p><strong>Hotel propio:</strong> {dashboardData.dashboardData[0].name}</p>
          <p><strong>effective_compset_name:</strong> {dashboardData.dashboardData[0].effective_compset_name || 'No definido'}</p>
          <p><strong>effective_compset_id:</strong> {dashboardData.dashboardData[0].effective_compset_id || 'No definido'}</p>
          <p><strong>Hoteles en compset_rooms_breakdown_for_card:</strong> {dashboardData.dashboardData[0].compset_rooms_breakdown_for_card?.length || 0}</p>
          
          <h3>Lista de hoteles del compset:</h3>
          <ul>
            {dashboardData.dashboardData[0].compset_rooms_breakdown_for_card?.map(h => (
              <li key={h.hotel_id}>
                <strong>{h.name}</strong> ({h.is_own ? 'Propio' : 'Competencia'}) – ID: {h.hotel_id}
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p>No se encontró información del compset en el dashboard.</p>
      )}
    </div>
  );
}

export default TestCompset;